module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/boxoffice/boxoffice-contents/boxoffice-contents.component.scss
// module id = ./src/app/routes/boxoffice/boxoffice-contents/boxoffice-contents.component.scss
// module chunks = 9